import React from 'react';
import styles from './TopBar.module.css';

const ServiceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32" fill="currentColor">
    <path d="M16 17.763a.639.639 0 0 1-.639-.639v-.857a1.919 1.919 0 0 1 1.278-1.808 1.918 1.918 0 1 0-2.557-1.809.639.639 0 1 1-1.278 0 3.2 3.2 0 1 1 4.261 3.013.643.643 0 0 0-.426.6v.858a.638.638 0 0 1-.636.642Zm-.963 1.837a.959.959 0 1 0 .963-.963.959.959 0 0 0-.963.963Zm14.1-4.919c0 5.767-5.895 10.459-13.141 10.459a19.161 19.161 0 0 1-3.562-.387L7.9 27.679a.624.624 0 0 1-.34.1.615.615 0 0 1-.283-.068.622.622 0 0 1-.341-.522l-.287-5.147a9.6 9.6 0 0 1-3.79-7.342C2.859 8.913 8.754 4.221 16 4.221s13.141 4.691 13.141 10.456Zm-1.25 0C27.891 9.6 22.556 5.471 16 5.471S4.109 9.6 4.109 14.68A8.337 8.337 0 0 0 7.62 21.2a.626.626 0 0 1 .264.476l.244 4.367 3.853-2.489a.617.617 0 0 1 .484-.083 15.526 15.526 0 0 0 3.535.415c6.556 0 11.891-4.131 11.891-9.209Z" />
  </svg>
);

const ContactIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32" fill="currentColor">
    <path d="M26.5,4.5H5.5a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1H9.5v3.96a.5.5,0,0,0,.8.4l5.51-4.36H26.5a1,1,0,0,0,1-1V5.5A1,1,0,0,0,26.5,4.5Zm0,17H15.19L10.5,25.04V21.5h-5V5.5h21Z"/>
    <circle cx="10" cy="13" r="1.1"/>
    <circle cx="16" cy="13" r="1.1"/>
    <circle cx="22" cy="13" r="1.1"/>
  </svg>
);

const TopBar = (props) => {
  const serviceHref = props.serviceHref || '/customer-service';
  const contactHref = props.contactHref || '/customer-service/contact-us';

  return (
    <div className={styles.topbar}>
      <div className={styles.inner}>
        <div className={styles.links}>
          <a href={serviceHref} className={styles.link}>
            <ServiceIcon />
            <span>Kundenservice</span>
          </a>
          <a href={contactHref} className={`${styles.link} ${styles.spaced}`}>
            <ContactIcon />
            <span>Kontakt</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;